
import { defineComponent } from 'vue'
import Accordion from 'primevue/accordion'
import AccordionTab from 'primevue/accordiontab'
import schedulerTimingOutputOutputTabDescriptor from '../SchedulerTimingOutputOutputTabDescriptor.json'

export default defineComponent({
    name: 'scheduler-java-class-accordion',
    components: { Accordion, AccordionTab },
    props: { propDocument: { type: Object }, functionalities: { type: Array }, datasets: { type: Array }, jobInfo: { type: Object } },
    data() {
        return {
            schedulerTimingOutputOutputTabDescriptor,
            document: null as any,
            javaClassPathDirty: false
        }
    },
    computed: {
        javaClassPathHelp(): string {
            return (this.document.javaclasspath?.length ?? '0') + ' / ' + schedulerTimingOutputOutputTabDescriptor.accordion.javaClass.classPathMaxLength
        }
    },
    watch: {
        propDocument() {
            this.loadDocument()
        }
    },
    created() {
        this.loadDocument()
    },
    methods: {
        loadDocument() {
            this.document = this.propDocument
            this.document.invalid.invalidJavaClass = false
            this.validateDocument()
        },
        setJavaClassPathValidation() {
            this.javaClassPathDirty = true
            this.validateDocument()
        },
        validateDocument() {
            this.document.invalid.invalidJavaClass = !this.document.javaclasspath || this.document.javaclasspath.length === 0
        }
    }
})
